import React, { useEffect, useState } from "react";
import axios from "axios";
import Widget from "Components/Common/Widget/Widget";
import { GiMoneyStack } from "react-icons/gi";
import { TbSquareRoundedCheck, TbSquareRoundedX } from "react-icons/tb";
import { MdOutlinePending } from "react-icons/md";

import ApproveReq from "Components/WithdrawalRequest/ApproveRequest/ApproveReq";

const Approve = () => {
  const [stats, setStats] = useState({
    totalRequests: { count: 0, amount: 0 },
    totalApproved: { count: 0, amount: 0 },
    totalPending: { count: 0, amount: 0 },
    totalRejected: { count: 0, amount: 0 },
  });

  const fetchStats = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/tpi-payout/users/stats`
      );
      if (data.success) {
        setStats(data.stats);
      }
    } catch (err) {
      console.error("Error fetching stats:", err);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return (
    <>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<GiMoneyStack className="h-6 w-6" />}
          title={"Total Requests Raised"}
          subtitle={stats.totalRequests.count}
          amount={stats.totalRequests.amount}
        />
        <Widget
          icon={<TbSquareRoundedCheck className="h-6 w-6" />}
          title={"Total Approved"}
          subtitle={stats.totalApproved.count}
          amount={stats.totalApproved.amount}
        />
        <Widget
          icon={<MdOutlinePending className="h-6 w-6" />}
          title={"Total Pending"}
          subtitle={stats.totalPending.count}
          amount={stats.totalPending.amount}
        />
        <Widget
          icon={<TbSquareRoundedX className="h-6 w-6" />}
          title={"Total Rejected"}
          subtitle={stats.totalRejected.count}
          amount={stats.totalRejected.amount}
        />
      </div>

      
      <ApproveReq
        fetchStats={fetchStats}
        setStatistics={(newStats) => {
          setStats((prev) => ({
            ...prev,
            totalRequests: {
              count: newStats.total,
              amount: newStats.totalAmount,
            },
            totalApproved: {
              count: newStats.approved,
              amount: newStats.approvedAmount,
            },
            totalPending: {
              count: newStats.pending,
              amount: newStats.pendingAmount,
            },
            totalRejected: {
              count: newStats.rejected,
              amount: newStats.rejectedAmount,
            },
          }));
        }}
      />
      
    </>
  );
};


export default Approve;
